export const FETCH_PRODUCT_STOCK_DATA_REQUEST = 'FETCH_PRODUCT_STOCK_REQUEST';
export const FETCH_PRODUCT_STOCK_DATA_SUCCESS = 'FETCH_PRODUCT_STOCK_SUCCESS';
export const FETCH_PRODUCT_STOCK_DATA_FAILURE = 'FETCH_PRODUCT_STOCK_FAILURE';


export const FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_REQUEST = 'FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_REQUEST';
export const FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_SUCCESS = 'FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_SUCCESS';
export const FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_FAILURE = 'FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_FAILURE';

export const SET_WAREHOUSE_STOCK_RADIO_BTN = 'SET_WAREHOUSE_STOCK_RADIO_BTN';
